export default __webpack_public_path__ + "static/media/rose1.983afe32.jpg";